import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { SalesPurchaseProperty } from '../../../models';
import { TmsWebBaseEditService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class SalesPurchasePropertyService extends TmsWebBaseEditService<SalesPurchaseProperty, SalesPurchaseProperty> {
  constructor() {
    super('SalesPurchaseProperty', $localize`Sales Purchase Property`);
  }

  getProperties(sales: boolean, purchases: boolean): Observable<SalesPurchaseProperty[]> {
    return this.httpService.get<SalesPurchaseProperty[]>(
      `${this.apiUrl}/GetProperties?sales=${sales}&purchases=${purchases}`,
    );
  }
}
